import { render, staticRenderFns } from "./SharedRecordsPage.vue?vue&type=template&id=1059a0cc&scoped=true"
import script from "./SharedRecordsPage.vue?vue&type=script&lang=js"
export * from "./SharedRecordsPage.vue?vue&type=script&lang=js"
import style0 from "./SharedRecordsPage.vue?vue&type=style&index=0&id=1059a0cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1059a0cc",
  null
  
)

export default component.exports